import React, { useState } from 'react';

import { PortfolioSettlementRule } from '@ndvr/billing-api';

import { useRequiredParams } from 'utils';
import { AccountNameLink, Text, VerticalLayout } from 'widgets';

import { useDeletePortfolioSettlementRule, usePortfolioSettlementRuleTimeline } from './billing-queries';
import { SettlementOverrideDrawer } from './drawers/SettlementOverrideDrawer';
import { TimelinePanel } from './TimelinePanel';
import { SettlementTitle } from './widgets/SettlementTitle';
import { TimelineHeader } from './widgets/TimelineHeader';

export const SettlementOverridesPanel = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);

    const { data: timeline, isLoading } = usePortfolioSettlementRuleTimeline(globalAccountGUID);
    const { mutateAsync: deletePortfolioSettlementRule } = useDeletePortfolioSettlementRule(globalAccountGUID);

    const [editedRule, setEditedRule] = useState<PortfolioSettlementRule>();
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <>
            <TimelineHeader
                title="Settlement Overrides"
                buttonLabel="+ New Settlement Override"
                onClick={() => {
                    setEditedRule(undefined);
                    setDrawerOpen(true);
                }}
            />
            <TimelinePanel
                timeline={timeline}
                timelineForOverrides
                isLoading={isLoading}
                onEdit={(rule) => {
                    setEditedRule(rule);
                    setDrawerOpen(true);
                }}
                onDelete={(rule) => deletePortfolioSettlementRule(rule.portfolioSettlementRuleGUID)}
                firstColumnRenderer={({ rule }) => (
                    <VerticalLayout>
                        <AccountNameLink accountGUID={rule.portfolioGUID} />
                        <Text $themeColor="subtle">Account</Text>
                    </VerticalLayout>
                )}
                secondColumnRenderer={({ rule }) => (
                    <VerticalLayout>
                        <SettlementTitle
                            settlementType={rule.settlementType}
                            portfolioGUID={rule.portfolioForSettlement}
                        />
                        <Text $themeColor="subtle">Settlement override</Text>
                    </VerticalLayout>
                )}
            />
            {drawerOpen && (
                <SettlementOverrideDrawer portfolioSettlementRule={editedRule} onClose={() => setDrawerOpen(false)} />
            )}
        </>
    );
};
